<template>
  <OrgObjectHeader
    type="Department"
    :name="name"
    :code="formattedCode"
    :status="status"
    :readiness="readinessPercent"
    :last_month_readiness="lastMonthReadiness"
    :chatter-unread-count="chatterUnreadCount"
    :menu-items="menuItems"
    @chatterClick="handleChatterClick"
    @optionClick="handleOptionClick"
  >
    <template v-if="$slots.icon" #icon>
      <slot name="icon" />
    </template>
  </OrgObjectHeader>
</template>

<script setup>
import { computed } from "vue";
import OrgObjectHeader from "@components/OrgObjectHeader/OrgObjectHeader.vue";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  code: {
    type: String,
    default: "",
  },
  status: {
    type: String,
    default: "",
  },
  readiness: {
    type: Object,
    default: null,
  },
  chatterUnreadCount: {
    type: Number,
    default: 0,
  },
  menuItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["chatter-click", "menu-click"]);

const formattedCode = computed(() => {
  if (!props.code) return "";
  return props.code.startsWith("#") ? props.code : `#${props.code}`;
});

const readinessPercent = computed(() => props.readiness?.percent ?? 0);

const lastMonthReadiness = computed(() => {
  if (!props.readiness || props.readiness.changePercent == null) return null;
  return props.readiness.percent - props.readiness.changePercent;
});

const handleChatterClick = () => {
  emit("chatter-click");
};

const handleOptionClick = ({ item }) => {
  emit("menu-click", item);
};
</script>
